import { render, staticRenderFns } from "./Lava.vue?vue&type=template&id=b0dd98e2"
import script from "./Lava.vue?vue&type=script&lang=js"
export * from "./Lava.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports